import { Typography } from '@mui/material';
import { getClient } from '../../lib/info';

export const Privacy = (): JSX.Element => {
  const client = getClient();

  return (
    <>
      <Typography variant="pageTitle">Privacy policy</Typography>
      <div className="body padding-top-m padding-bottom-l" id="body">
        <div
          className="default-page"
          style={{ textAlign: 'left' }}
          dangerouslySetInnerHTML={{
            __html: client?.company?.privacyPolicy ?? '<div></div>',
          }}
        >
          {/* {parse(client?.company?.privacyPolicy ?? '<div></div>')} */}
        </div>
      </div>
    </>
  );
};
